import React, { useMemo, useState, useEffect, useContext } from "react";
import { Form } from "react-bootstrap";
import { FiEdit2, FiEye, FiSearch, FiX } from "react-icons/fi";
import { TranslatorContext } from "../../../context/Translator";
import { AnchorComponent } from "../../elements";

export default function SellerProductsTableComponent({ thead, tbody, activeTab }) {
    const { t } = useContext(TranslatorContext);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState("");

    useEffect(() => {
        setData(tbody || []);
    }, [tbody]);

    const filteredData = useMemo(() => {
        const query = search.trim().toLowerCase();
        if (!query) return data;

        return data.filter((item) => [
            item?.product_code,
            item?.title,
            item?.category?.name || item?.category,
            item?.brand?.name || item?.brand,
            item?.product_condition,
        ].some((value) => String(value || "").toLowerCase().includes(query)));
    }, [data, search]);

    return (
        <>
        <div className="d-flex justify-content-between align-items-center gap-3 flex-wrap mb-3">
            <div className="position-relative" style={{ minWidth: 260, maxWidth: 420, flex: "1 1 260px" }}>
                <FiSearch className="position-absolute text-muted" style={{ left: 12, top: 12 }} aria-hidden="true" />
                <Form.Control
                    type="search"
                    value={search}
                    onChange={(event) => setSearch(event.target.value)}
                    placeholder="Filter by product code, title, category, or brand"
                    aria-label="Filter products"
                    className="ps-5 pe-5"
                />
                {search && (
                    <button
                        type="button"
                        className="btn btn-link text-muted position-absolute p-0"
                        style={{ right: 12, top: 9 }}
                        onClick={() => setSearch("")}
                        aria-label="Clear product filter"
                    >
                        <FiX />
                    </button>
                )}
            </div>
            <small className="text-muted">{filteredData.length} of {data.length} products</small>
        </div>
        <div className="mc-table-responsive">
            <table className="mc-table product">
                <thead className="mc-table-head primary">
                    <tr>
                        {thead?.map((item, index) => (
                            <th key={index}>{t(item)}</th>
                        ))}
                    </tr>
                </thead>
                <tbody className="mc-table-body even">
                    {filteredData.length > 0 ? (
                        filteredData.map((item, index) => {
                            const pImage = item?.card_img || item?.first_img
                                ? `${process.env.REACT_APP_IMG_URL}${item.card_img || item.first_img}`
                                : "";
                            const pTitle = item?.title || "N/A";
                            const pCode = item?.product_code || "N/A";
                            const pCondition = item?.product_condition || "N/A";
                            const pQty = item?.product_qty ?? 0;

                            const pCategory = typeof item?.category === "object"
                                ? item?.category?.name
                                : (item?.category || "N/A");

                            const pBrand = typeof item?.brand === "object"
                                ? item?.brand?.name
                                : (item?.brand || "N/A");

                            const pricePresent = item?.sell_price_dollar || 0;

                            return (
                                <tr key={item?.id || index}>
                                    <td><div className="mc-table-check">{pCode}</div></td>
                                    <td>
                                        <div className="mc-table-product md">
                                            {pImage && <img src={pImage} alt={pTitle} />}
                                            <div className="mc-table-group">
                                                <h6>{pTitle}</h6>
                                                <p>{pCondition}</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>{pCategory}</td>
                                    <td>{pBrand}</td>
                                    <td><span className="text-capitalize">{pCondition}</span></td>
                                    <td>
                                        <div className="mc-table-price">
                                            <p>${pricePresent}</p>
                                        </div>
                                    </td>
                                    <td>{pQty}</td>
                                    <td>
                                        <div className="mc-table-action">
                                            <AnchorComponent
                                                to={`/store-seller/product-view/${item?.id || ''}`}
                                                state={{ item }}
                                                title="View"
                                                className="view d-inline-flex align-items-center justify-content-center"
                                            >
                                                <FiEye size={18} aria-hidden="true" />
                                            </AnchorComponent>

                                            {activeTab === "pending" && (
                                                <AnchorComponent
                                                    to={'/seller-product-edit'}
                                                    state={{ item }}
                                                    title="Edit"
                                                    className="edit d-inline-flex align-items-center justify-content-center"
                                                >
                                                    <FiEdit2 size={18} aria-hidden="true" />
                                                </AnchorComponent>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan={thead?.length || 8} className="text-center py-4">
                                {data.length ? "No products match this filter." : t("no_products_found")}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
        </>
    );
}